import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

const TOKEN_KEY = "nm_admin_token";
const CFX_TOKEN_KEY = "nm_cfx_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getCfxToken = () => localStorage.getItem(CFX_TOKEN_KEY);
export const setCfxToken = (t) => localStorage.setItem(CFX_TOKEN_KEY, t);
export const clearCfxToken = () => localStorage.removeItem(CFX_TOKEN_KEY);

export const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Separate axios instance for CFX-authenticated calls
const cfxClient = axios.create({ baseURL: API });
cfxClient.interceptors.request.use((config) => {
  const t = getCfxToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default client;

export const fetchConfig = () => client.get("/config").then((r) => r.data);
export const updateConfig = (cfg) => client.put("/config", cfg).then((r) => r.data);
export const resetConfig = () => client.post("/config/reset").then((r) => r.data);
export const login = (email, password) =>
  client.post("/auth/login", { email, password }).then((r) => r.data);
export const me = () => client.get("/auth/me").then((r) => r.data);

// CFX auth
export const cfxLoginUrl = () => {
  const origin = encodeURIComponent(window.location.origin);
  return `${API}/auth/cfx/login?return_to=${origin}`;
};
export const cfxMe = () => cfxClient.get("/auth/cfx/me").then((r) => r.data);
export const generateCfxKeys = () =>
  client.post("/auth/cfx/generate-keys").then((r) => r.data);

// Cart checkout
export const tebexCheckout = (items) =>
  cfxClient.post("/checkout/tebex", { items }).then((r) => r.data);

// Latest Release "Purchase Now" — single-package checkout (Tebex)
export const tebexCheckoutLatestRelease = () =>
  cfxClient.post("/checkout/tebex/latest-release").then((r) => r.data);

// Admin orders
export const fetchOrders = () => client.get("/admin/orders").then((r) => r.data);
export const fetchStorage = () => client.get("/admin/storage").then((r) => r.data);
export const fetchLiveStats = (refresh = false) =>
  client.get(`/stats/live${refresh ? "?refresh=1" : ""}`).then((r) => r.data);
export const refreshOrderFromTebex = (order_id) =>
  client.post(`/admin/orders/${order_id}/refresh`).then((r) => r.data);
export const deleteOrder = (order_id) =>
  client.delete(`/admin/orders/${order_id}`).then((r) => r.data);
export const syncAllOrders = () =>
  client.post("/admin/orders/sync-all").then((r) => r.data);
export const fetchOrphanEvents = () =>
  client.get("/admin/tebex/orphan-events").then((r) => r.data);

// Admin: pull live package list from connected Tebex storefront
export const fetchTebexPackages = () =>
  client.get("/admin/tebex/packages").then((r) => r.data);

// Admin file uploads (MongoDB GridFS via backend)
export const uploadAdminFile = (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return client
    .post("/admin/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    })
    .then((r) => r.data);
};

export const importAdminUrl = (url) =>
  client.post("/admin/import-url", { url }).then((r) => r.data);

export const deleteAdminFile = (id) =>
  client.delete(`/admin/files/${id}`).then((r) => r.data);

// Raffle
export const fetchRaffle = () => client.get("/raffle").then((r) => r.data);
export const fetchRaffleMe = () => cfxClient.get("/raffle/me").then((r) => r.data);
export const tebexCheckoutRaffle = (quantity = 1) =>
  cfxClient.post("/checkout/tebex/raffle", { quantity }).then((r) => r.data);
export const fetchAdminRaffle = () => client.get("/admin/raffle").then((r) => r.data);
export const resetRaffle = () => client.post("/admin/raffle/reset").then((r) => r.data);

